import {http} from '@utils';
import {NewGamePageInfo} from '@/common-pages/casino/casino.service';
import {LotteryGameCardItem} from '@/common-pages/lottery/lottery.service';

export function getGameList(params: {
  nickName: string;
  pageNo?: number;
  pageSize?: number;
}) {
  return http.post<any, NewGamePageInfo>('app/homeGames/getList', params);
}

export interface LotteryGameFloorItem {
  // 楼层icon图片
  categoryPic: string;
  gamesList: LotteryGameCardItem[];
  // 楼层标题
  name: string;
  // 楼层唯一key
  uniqueKey: string; // hotGames lotteryV2 indianCasino liveCasinoV2 Slots New Games
  id: number;
  currentTimestamp?: number;
}
export const getLotteryGames = (position = 7) => {
  return http.post<
    {
      position: 7;
    },
    LotteryGameFloorItem[]
  >('app/homeGamesCategory/getAllListBySortV4', {
    position,
  });
};
